import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { history, fetchWrapper } from '_helpers';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// create slice

const name = 'student';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState,  extraReducers });

// exports

export const studentActions = { ...slice.actions, ...extraActions };
export const studentReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        user: JSON.parse(localStorage.getItem('user')),
        error: null
    }
}


function createExtraActions() {
    const baseUrl = `https://api.webtracktechnologies.com.au:8002`;
   //const registerUrl = `${process.env.REACT_APP_API_URL}/frontend/auth/register/step-1`;

    return {
        getStudentById: getStudentById(),
        getStudents:getStudents(),
    };    

    function getStudentById() {
        return createAsyncThunk(
            `${name}/student`,
            async ({ userId }) => await fetchWrapper.get(`${baseUrl}/student/single/`+userId)
        );
    }

    function getStudents() {
        return createAsyncThunk(
            `${name}/student`,
            async () => await fetchWrapper.get(`${baseUrl}/student/allstudents`)
        );
    }

}

function createExtraReducers() {
    return {
        ...getStudentById(),
        ...getStudents(),
    };

    function getStudentById() {
        var { pending, fulfilled, rejected } = extraActions.getStudentById;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const student = action.payload;
             // console.log(student,'get register user');  return false;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('student', JSON.stringify(student));
                state.student = student.data;

            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

    function getStudents() {
        var { pending, fulfilled, rejected } = extraActions.getStudents;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const student = action.payload;
             // console.log(student,'get register user');  return false;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('student', JSON.stringify(student));
                state.student = student.data;

            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

}
